import service from './request'
import md5 from 'js-md5';
// web网站接入
// 获取aai登录地址
export const cloudLogin = data => {
    return service({
        url: `/oidc/authorize`,
        method: 'post',
    })
}
// aai回调返回处理code
export const dealCode = code => {
    return service({
        url: `/oidc/token`,
        method: 'post',
        data:{
            code:code
        }
    })
}
// 使用access_token 获取用户信息
export const userinfo = data => {
    console.log(data)
    return service({
        url: `/oidc/userinfo?access_token=${data.access_token}&token_type=${data.token_type}`,
        method: 'get',
      
    })
}

// 用户登录
export const userLogin = data => {
    return service({
        url: `/system/userLogin`,
        method: 'post',
        data: {
            loginName: data.loginName,
            password: md5(data.password),
        }
    })
}
// 校验token是否正确
export const checkJwt = data => {
    return service({
        url: `/checkJwt?token=${data}`,
        method: 'get',
    })
}

// 获取验证码
export const verificationCode = data => {
    return service({
        url: `/system/getActiveCodeByEmail?email=${data}`,
        method: 'get',
    })
}
// 验证账号是否被注册
export const checkAccount = data => {
    return service({
        url: `/system/checkAccount?loginName=${data}`,
        method: 'get',
    })
}

// 验证邮箱是否被注册
export const checkEmail = data => {
    return service({
        url: `/system/checkEmail?email=${data}`,
        method: 'get',
    })
}

// 获取验证码
export const getActiveCode = data => {
    return service({
        url: `/system/getActiveCodeByEmail?email=${data}`,
        method: 'get',
    })
}

// 用户注册
export const userSignup = data => {

    return service({
        url: `/system/signup`,
        method: 'post',
        data: {
            loginName: data.loginName,
            password: md5(data.password),
            email: data.email,
            confirmPassword: md5(data.password),
            activeCode: data.activeCode
        }
    })
}
// 修改密码
export const forgetPassword = data => {
    return service({
        url: `/system/forgetPassword`,
        method: 'POST',
        data: {
            loginName: data.loginName,
            password: md5(data.password),
            email: data.email,
            confirmPassword: md5(data.password),
            activeCode: data.activeCode
        }
    })
}
// 退出
export const logout = data => {
    return service({
        url: `/system/logout?loginName=${data}`,
        method: 'get',
    })
}

export const EmailCode = email => { //获取验证码
    return service({
        url: `/system/user/getActiveCodeByEmail?email=${email}`,
        method: 'get',
    })
}

export const Signup = data => { //注册
    return service({
        url: `/system/register`,
        method: 'post',
        data: {
            loginName: data.loginName,
            email: data.email,
            password: data.password,
            confirmPassword: data.confirmPassword,
            activeCode: data.activeCode

        }
    })
}

export const checkEmailUnique = data => { //校验邮箱
    return service({
        url: `/system/user/checkEmailUnique?email=${data}`,
        method: 'get',
    })
}

export const checkLoginNameUnique = data => { //校验用户名
    return service({
        url: `/system/user/checkLoginNameUnique?loginName=${data}`,
        method: 'get',
    })
}


export const updatePassword = data => { //忘记密码
    return service({
        url: `/system/user/forgetPassword`,
        method: 'post',
        data: {
            loginName: data.loginName,
            email: data.email,
            password: data.password,
            confirmPassword: data.confirmPassword,
            activeCode: data.activeCode
        }
    })
}


// 感兴趣区上传
export const userArea = data => { //忘记密码
    return service({
        url: `/user-area`,
        method: 'post',
        data: {
            areaType: data.areaType,
            geojson: data.geojson,
            userId: data.userId,
            info: data.info,
        }
    })
}

//删除感兴趣区
export const deleteUserInterest = data => { //忘记密码
    return service({
        url: `user-area/${data}`,
        method: 'delete',

    })
}


//查询感兴趣区列表
export const userInterestArray = data => { //忘记密码
    return service({
        url: `user-area?userId=${data.userId}&areaType=${data.areaType}`,
        method: 'get',

    })
}

/* 根据用户编号获取当前用户的行为轨迹 */
export const userBuffer = data => {
    /* ${data.dataId} */
    return service({
        url: `user-buffer/${data}`,
        method: 'get',
    })
}

/* 根据用户编号获取当前用户的行为轨迹 */
export const deleteUserBuffer = data => {
    /* ${data.dataId} */
    return service({
        url: `user-buffer/${data}`,
        method: 'delete',
    })
}


/* 根据用户编号获取当前用户的行为轨迹 */
export const saveUserBuffer = data => {
    /* ${data.dataId} */
    return service({
        url: `user-buffer`,
        method: 'post',
        data: {
            dataId: data.dataId,
            distance: data.distance,
            randomNumber: data.randomNumber,
            userId: data.userId,
            productName: data.productName,
        }
    })
}


